import styled from "styled-components";

interface ColorsProps {
  backgroundSecondary?: string;
  brandTertiary?: string;
  backgroundTertiary?: string;
  brandPrimary?: string;
}

export const DiscountContainer = styled.div<ColorsProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  background: ${({ backgroundSecondary }) => backgroundSecondary};
  border: 1px solid ${({ backgroundTertiary }) => backgroundTertiary};
  border-radius: 8px;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    border-block: 1px solid ${({ backgroundTertiary }) => backgroundTertiary};
    border-radius: 0px;
  }
`;

export const DiscountLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const DiscountIconContainer = styled.div<ColorsProps>`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ brandTertiary }) => brandTertiary};
  margin-right: 10px;
`;

export const DiscountText = styled.div<ColorsProps>`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ brandTertiary }) => brandTertiary};

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ArowSmallIconContainer = styled.div<ColorsProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  height: 24px;
  width: 24px;
  color: ${({ brandPrimary }) => brandPrimary};

  @media screen and (max-width: 768px) {
    height: 20px;
    width: 20px;
  }
`;
